import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";


export const TableOne = ({ capitalGainResult, selectedYr }) => {
    const raw = capitalGainResult?.result || [];
    const result = raw.length > 0 ? raw.slice(0, -1) : [];

    console.log("TableOne result:", result);


    // Map: category -> merged funds
    const categoryMap = new Map();

   result.forEach((fund) => {
    const category = fund.Category || "Others";
    if (!categoryMap.has(category)) categoryMap.set(category, new Map());

    const fundMap = categoryMap.get(category);

    const key = fund.Fund; // whole fund identified by fund name

    fundMap.set(key, {
        scheme: fund.Fund,
        isinNo: fund.FundDetail[0]?.ISIN_NO || "",
        folio: fund.FundDetail[0]?.Folio || "",
        shortGain: Number(fund.FundTotal?.STGain || 0),
        longGain: Number(fund.FundTotal?.LTGain || 0),
        totalGain: Number(fund.FundTotal?.Gainloss || 0),
    });
});


    // Convert merged funds to arrays
    const categoryFunds = {};
    categoryMap.forEach((fundMap, category) => {
        categoryFunds[category] = Array.from(fundMap.values()).map(f => ({ ...f, totalGain: f.shortGain + f.longGain }));
    });

    // Grand totals
    const grandTotals = Object.values(categoryFunds)
    .flat() // agar nested arrays hain
    .reduce(
        (acc, f) => {
        acc.short += Number(f.shortGain || 0);
        acc.long  += Number(f.longGain  || 0);
        return acc;
        },
        { short: 0, long: 0 }
    );

    


    // Summary
    const summaryName = result[0]?.FundDetail[0]?.Scheme || "Investor";
    const memberType = "Individual";


    const [visibleIndexes, setVisibleIndexes] = useState({});
const toggleVisibility = (key) => {
  setVisibleIndexes((prev) => ({
    ...prev,
    [key]: !prev[key],
  }));
};


    return (
        <>
        <div className="table-scroll-cgr-2 mt-4 d-none d-md-block">
            <table className="table">
                <thead className="tablehead">
                    <tr>
                        <th className="back-clrgreen txt-color-revers">Scheme Name</th>
                        <th className="back-clrgreen txt-color-revers">ISIN Number</th>
                        <th className="back-clrgreen txt-color-revers">Folio Number</th>
                        <th className="back-clrgreen txt-color-revers">Short Term Capital Gain</th>
                        <th className="back-clrgreen txt-color-revers">Long Term Capital Gain</th>
                        <th className="back-clrgreen txt-color-revers">Total Gain/Loss</th>
                    </tr>
                </thead>
                <tbody>

                  
                    {Object.entries(categoryFunds).map(([category, funds]) => {
                        console.log('funds',funds,category,categoryFunds);
                        
                        const categoryTotals = funds.reduce(
                            (acc, f) => {
                                acc.short += f.shortGain;
                                acc.long += f.longGain;
                                return acc;
                            },
                            { short: 0, long: 0 }
                        );
                        const categoryTotal = categoryTotals.short + categoryTotals.long;

                        return (
                            <React.Fragment key={category}>
                                <tr className="headingdebt">
                                    <td colSpan={6}><strong>{category} Funds</strong></td>
                                </tr>

                                {funds.map((fund, idx) => (
                                    <tr key={idx}>
                                        <td>{fund.scheme}</td>
                                        <td>{fund.isinNo}</td>
                                        <td>{fund.folio}</td>
                                        <td>{Number(fund.shortGain || 0).toFixed(2)}</td>
                                        <td>{Number(fund.longGain || 0).toFixed(2)}</td>
                                        <td>{Number(fund.totalGain || 0).toFixed(2)}</td>
                                    </tr>
                                ))}


                                <tr className="grey-bg total">
                                    <td>{category} Funds Total</td>
                                    <td></td>
                                    <td></td>
                                    <td>{Number(categoryTotals.short).toFixed(2)}</td>
                                    <td>{Number(categoryTotals.long).toFixed(2)}</td>
                                    <td>{Number(categoryTotal).toFixed(2)}</td>
                                </tr>
                            </React.Fragment>
                        );
                    })}

                    <tr className="grey-bg total">
                        <td>Total Gain / Loss for Financial {selectedYr}</td>
                        <td></td>
                        <td></td>
                        <td>{Number(grandTotals.short).toFixed(2)}</td>
                        <td>{Number(grandTotals.long).toFixed(2)}</td>
                        <td>{Number(grandTotals.short + grandTotals.long).toFixed(2)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        {/* ================= MOBILE VIEW (TableOne) ================= */}
        <div className="d-block d-md-none mt-4">

          {Object.entries(categoryFunds).map(([category, funds], catIndex) => {
            
            const categoryKey = `cat-${catIndex}`;
            const isCatOpen = visibleIndexes[categoryKey];

            // Category totals
            const categoryTotals = funds.reduce(
              (acc, f) => {
                acc.short += f.shortGain;
                acc.long += f.longGain;
                return acc;
              },
              { short: 0, long: 0 }
            );
            const categoryTotal = categoryTotals.short + categoryTotals.long;

            return (
              <div key={category} className="mb-3">

                {/* CATEGORY CARD */}
                <div
                  className="card shadow-sm p-2 mb-2"
                  onClick={() => toggleVisibility(categoryKey)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="fw-bold fs-5 mb-0">{category} Funds</p>

                    {isCatOpen ? (
                      <FaMinus className="fs-4 text-success" />
                    ) : (
                      <FaPlus className="fs-4 text-success" />
                    )}
                  </div>
                </div>

                {/* CATEGORY DETAILS */}
                {isCatOpen && (
                  <div>

                    {funds.map((fund, fundIndex) => {
                      const fundKey = `${category}-${fundIndex}`;
                      const isOpen = visibleIndexes[fundKey];

                      return (
                        <div key={fundIndex} className="card shadow-sm p-2 mb-3">

                          {/* FUND HEADER */}
                          <div
                            className="d-flex justify-content-between align-items-center"
                            onClick={() => toggleVisibility(fundKey)}
                            style={{ cursor: "pointer" }}
                          >
                            <p className="fw-bold mb-0">
                              {fund.scheme}
                              <br />
                              <span className="text-color fs-12">
                                Folio: {fund.folio} | ISIN: {fund.isinNo}
                              </span>
                            </p>

                            {isOpen ? (
                              <FaMinus className="fs-4 text-success" />
                            ) : (
                              <FaPlus className="fs-4 text-success" />
                            )}
                          </div>

                          {/* FUND BODY */}
                          {isOpen && (
                            <div className="mt-2">

                              <div className="d-flex justify-content-between py-2 border-bottom">
                                <span className="fw-bold">Short Term Gain:</span>
                                <span>{Number(fund.shortGain).toFixed(2)}</span>
                              </div>

                              <div className="d-flex justify-content-between py-2 border-bottom">
                                <span className="fw-bold">Long Term Gain:</span>
                                <span>{Number(fund.longGain).toFixed(2)}</span>
                              </div>

                              <div className="d-flex justify-content-between py-2 border-bottom">
                                <span className="fw-bold text-success">Total Gain/Loss:</span>
                                <span className="fw-bold">
                                  {Number(fund.totalGain).toFixed(2)}
                                </span>
                              </div>

                            </div>
                          )}

                        </div>
                      );
                    })}

                    {/* CATEGORY TOTAL */}
                    <div className="bg-light p-2  mb-3">
                      <span className="fw-bold mb-1">{category} Funds Total</span>

                      <div className="d-flex justify-content-between">
                        <span>Short Term Gain:</span>
                        <span>{Number(categoryTotals.short).toFixed(2)}</span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span>Long Term Gain:</span>
                        <span>{Number(categoryTotals.long).toFixed(2)}</span>
                      </div>

                      <div className="d-flex justify-content-between fw-bold text-success">
                        <span>Total Gain/Loss:</span>
                        <span>{Number(categoryTotal).toFixed(2)}</span>
                      </div>
                    </div>

                  </div>
                )}

              </div>
            );
          })}

          {/* GRAND TOTAL */}
          <div className="bg-light p-2  fw-bold mt-4">
            <span >Total Gain/Loss for Financial {selectedYr}</span>

            <div className="d-flex justify-content-between">
              <span>Short Term:</span>
              <span>{Number(grandTotals.short).toFixed(2)}</span>
            </div>

            <div className="d-flex justify-content-between">
              <span>Long Term:</span>
              <span>{Number(grandTotals.long).toFixed(2)}</span>
            </div>

            <div className="d-flex justify-content-between text-success">
              <span>Total:</span>
              <span>{Number(grandTotals.short + grandTotals.long).toFixed(2)}</span>
            </div>
          </div>

        </div>

        </>
    );
};
